import { RefObject, useEffect } from "react";

const IGNORED_ELEMENTS = ["INPUT", "TEXTAREA"];

export default function useHandleKeyPress(
  keyTrigger: string,
  ref: RefObject<HTMLInputElement | HTMLButtonElement>,
) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const activeElement = document.activeElement as HTMLElement | null;
      if (
        activeElement &&
        (IGNORED_ELEMENTS.includes(activeElement.tagName) ||
          activeElement.isContentEditable)
      ) {
        return;
      }

      if (
        event.key === keyTrigger &&
        ref.current &&
        !(event.metaKey || event.ctrlKey)
      ) {
        event.preventDefault();
        ref.current.click();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [keyTrigger, ref]);
}
